import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_47: DocMigration = {
  maxSchemaVersion: "0.0.47",
  apply(json: any) {
    if (json.tables?.settings) {
      for (const tableId in json.tables.settings) {
        const table = json.tables.settings[tableId];
        if (table.type === "FOUNDATION_SETTINGS") {
          if (table.addPlumbingProps !== undefined) {
            table.dimensionPlumbingProps = table.addPlumbingProps;
            delete table["addPlumbingProps"];
          }
          if (table.addElectricalFloorProps !== undefined) {
            table.dimensionElectricalFloorProps = table.addElectricalFloorProps;
            delete table["addElectricalFloorProps"];
          }
        }
      }
    }
    return json;
  },
};

export default migration_0_0_47;
